/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Staff BFF
 * OpenAPI spec version: 1.0.0
 */
import {
  faker
} from '@faker-js/faker';

import type {
  OfferDetail,
  OfferListPage
} from '../schemas';

import {
  getOfferSummaryMock
} from '../schemas/index.faker';


export const getListOffersResponseMock = (overrideResponse: Partial<Extract<OfferListPage, object>> = {}): OfferListPage => ({items: Array.from({ length: faker.number.int({min: 1, max: 10}) }, (_, i) => i + 1).map(() => ({ ...getOfferSummaryMock() })), total: faker.number.int(), ...overrideResponse})

export const getGetOfferResponseMock = (overrideResponse: Partial<Extract<OfferDetail, object>> = {}): OfferDetail => ({id: faker.string.alpha({length: {min: 10, max: 20}}), name: faker.string.alpha({length: {min: 10, max: 20}}), status: faker.string.alpha({length: {min: 10, max: 20}}), description: faker.helpers.arrayElement([faker.string.alpha({length: {min: 10, max: 20}}), undefined]), updatedAt: faker.date.past().toISOString().slice(0, 19) + 'Z', ...overrideResponse})

